import { computed } from "vue";
import { useStore } from "vuex";
import yup from "@component_path/inquiry_form_common_module/customValidation";

export const useAddressField = (required, messages = {}) => {
  const fieldName = computed(() => "address");
  const validator = yup
    .string()
    .requirement(required, messages["requirement"] || "市区町村は必須項目です");

  return { validator, fieldName };
};

export const useAddressStore = () => {
  const store = useStore();

  const address = computed(() => store.state.formData.address);
  const dispatcher = computed(() => "formData/setAddress");
  const addressText = computed(() => store.getters.addressText);

  return { address, addressText, dispatcher };
};
